export enum TableCellAlignmentStyle {
    Left = "left",
    Right = "right",
    Center = "center",
    Justify = "justify",
    None = "",
}
